import React from "react";
import { STRINGS } from "../strings";
import { translate } from "../translate";
import { CHEVRON_RIGHT_SVG } from "../utils/svgs";
import { AppButton } from "./Generic/AppButton";
import { AppIcon } from "./Generic/AppIcon";
import { AppListItem } from "./Generic/AppList";
import { LinkChainIcon } from "../utils/icones";
import { iconColors } from "./Generic/AppIconColors";

type Props = {
  linkedPatientName: string;
  onClickOpen: () => void;
};

export default function LinkedPatientAppListItem(props: Props) {
  return (
    <AppListItem
      leading={<AppIcon stroke={iconColors.get("primary")} icon={<LinkChainIcon width={20} />} />}
      title={translate(STRINGS.LINKED_TO_ANOTHER_PATIENT)}
      extra={<AppListItem title={props.linkedPatientName} soft={true} />}
      trailing={
        <AppButton size="small" variant="outline" className="UserDetailsButton">
          {translate(STRINGS.VIEW_TASK)}
          <AppIcon icon={CHEVRON_RIGHT_SVG} size={12} />
        </AppButton>
      }
      onClick={props.onClickOpen}
    />
  );
}
